module.exports = __webpack_public_path__ + "img/6.5f0d2add.jpeg";